<template>
  <a-form-model ref='form' layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}"  :rules="rules">
    <a-form-model-item label='质疑对象表单' prop='formId' >
      <a-select v-model='model.formId' placeholder='请选择表单' @change="formIdChange()" showSearch :filterOption="filterOptionTip">
        <a-select-option :value='item.id' :key="item.id" v-for="item in formList">          
          <a-tooltip :title="item.description">
            {{ item.name }}
          </a-tooltip>
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label='质疑对象' prop='formItemId' >
      <a-select v-model='model.formItemId' placeholder='请选择元素' @change="formItemIdChange()" showSearch :filterOption="filterOption">
        <a-select-option :value='item.id' :key="item.id" v-for="item in formItemList">{{(item.number?item.number:"")+item.name}}</a-select-option>
      </a-select>
    </a-form-model-item>
    <template v-if="model.type ==='3'">    
      <a-form-model-item label='配置类型' v-if="model.formItemId" >
        <a-radio-group v-model="category2" :options='radioOptions2' @change="categorysChange2" />
      </a-form-model-item>
      <a-form-model-item label='选择答案选项' v-if="category2==='64'" prop='extend1Arr' >
        <a-select v-model='model.extend1Arr' placeholder='选择答案选项' showSearch :filterOption="filterOption" mode="multiple">
          <a-select-option :value='item.id' :key="item.id" v-for="item in formItemDictList">{{item.text}}</a-select-option>
        </a-select>
      </a-form-model-item>
    </template>
    <a-form-model-item label='质疑周期规则' prop='periodType' >
      <a-radio-group v-model='model.periodType' :options='radioOptions' @change="periodTypeChange"/>
    </a-form-model-item>
    <a-form-model-item  v-if='model.periodType==="2" ' label="周期" prop='periodItemId' >
      <a-select v-model='model.periodItemId' placeholder='请选择周期' >
        <a-select-option :value='item.id' :key="item.id" v-for="item in periodItemList">{{item.name}}</a-select-option>
      </a-select>
    </a-form-model-item>      
    <a-form-model-item v-if="model.type==='1' || model.type === '2'"   label="质疑程度" prop='level' >
      <a-radio-group v-model='model.level' style="width: 200px" >
        <a-radio value="1">
          普通质疑
        </a-radio>
        <a-radio value="2">
          严重质疑
        </a-radio>
      </a-radio-group>
    </a-form-model-item>    
    <a-form-model-item v-if="model.type==='1'" label="质疑类别" prop='category' >      
      <a-checkbox-group v-model="categorys" @change="categorysChange">
        <a-checkbox v-for="(item, key) in categoryList" :key="key" :value="item.id">{{ item.name }}</a-checkbox>
      </a-checkbox-group>
    </a-form-model-item>
    <a-form-model-item v-if="model.type==='2'"  label="终止类别" prop='category' >      
      <a-checkbox-group v-model="categorys" @change="categorysChange">
        <a-checkbox v-for="(item, key) in overVisitList" :key="key" :value="item.id">{{ item.name }}</a-checkbox>
      </a-checkbox-group>
    </a-form-model-item>   
  </a-form-model>
</template>

<script>
  import { getAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
export default {
  name: 'Step1',
  data() {
    return {
      model:{},
      radioOptions: [{ label: '所有周期', value: '1' }, { label: '指定周期', value: '2' }],
      radioOptions2: [{ label: '无', value: '1' },{ label: '隐藏题目', value: '32' }, { label: '隐藏答案选项', value: '64' }],
      formItemDictList:[],
      rules: {
        formId:[baseRules.requiredChange],
        formItemId:[baseRules.requiredChange],
        periodItemId:[baseRules.requiredChange],
        category2:[baseRules.requiredChange],
        extend1Arr:[baseRules.requiredChange],
      },
      formList:[],
      formItemList:[],
      periodItemList:[],
      categoryList:[{"id":1,"name":"数据核查"},{"id":2,"name":"质疑提示"}],
      categorys:[1],
      category2 : '1',
      overVisitList:[{"id":1,"name":"终止受试者"},{"id":2,"name":"终止分组周期"},{"id":4,"name":"变更戴牙后访视"}],
    }
  },
  created() {
    
  },
  mounted(){
    
  },
  methods: {
    view(model){
      if(!model.periodType){
        model.periodType = '1'
      }      
      if(!model.level){
        model.level = '1'
      }      
      this.model = JSON.parse(JSON.stringify(model))
      getAction('/project/projectForm/listAll',{projectId:this.model.projectId}).then(res=>{
        if(res.success){
          this.formList=res.result
        }
      })
      if(this.model.formId){
        getAction('/project/projectFormItem/listAll',{formId:this.model.formId,scale:'0'}).then(res=>{
          if(res.success){
            this.formItemList = res.result
            this.formItemIdChange(this.model.category)
          }
        })
      }
      console.log("this.model.category view:"+this.model.category)
      
      
      if(this.model.type ==='3'){
        this.category2 = this.model.category + ''
      }else{
        if(this.model.category>=0){
          this.categorys=[]
          if((this.model.category & 1)==1){
            this.categorys.push(1)
          }
          if((this.model.category & 2)==2){
            this.categorys.push(2)
          }
          if((this.model.category & 4)==4){
            this.categorys.push(4)
          }
        }else{
          this.categorys=[1]
          this.categorysChange()
        }
      }
      this.periodTypeChange()
    },
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      let result = false
      this.$refs.form.validate((valid, errorFields) => {
        if (valid) {
          result = true
        }
      })
      return result
    },
    formIdChange(){
      this.formItemList = []
      if(this.model.formItemId){
        this.model.formItemId = null
      }
      if(this.model.formId){
        getAction('/project/projectFormItem/listAll',{formId:this.model.formId,scale:'0'}).then(res=>{
          if(res.success){
            this.formItemList = res.result
          }
        })
      }
    },
    formItemIdChange(category){      
      if(this.model.type !='3'){
        return
      }
      if(!category){
        this.model.category = '1'
        this.category2 = '1'
      }

      if(this.model.formItemId){
        var formItem = this.formItemList.filter(item=>item.id==this.model.formItemId)[0]
        if(formItem.elementType==='select' || formItem.elementType==='check'){
          this.radioOptions2 = [{ label: '无', value: '1' },{ label: '隐藏题目', value: '32' }, { label: '隐藏答案选项', value: '64' }]
          this.formItemDictList = formItem.element.dictItemList
        }else{
          this.radioOptions2 = [{ label: '无', value: '1' },{ label: '隐藏题目', value: '32' }]
        }
      }
    },
    periodTypeChange(){
      if(this.periodItemList.length===0 && this.model.periodType==='2'){
        getAction('/project/projectPeriodItem/list',{projectId:this.model.projectId,halfway:'0'}).then(res=>{
          if(res.success){
            this.periodItemList=res.result
          }
        })
      }
    },
    // isShowChange(){
    //   if(this.model.category==='2'){
    //     var formItem = this.formItemList.filter(item=>item.id==this.model.formItemId)[0]
    //     //todo 展示当前题目的选项
    //     this.formItemDictList = formItem

    //   }
    // },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    filterOptionTip(input, option) {
      return option.componentOptions.children[0].componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    categorysChange(){      
      console.log("categorys:"+ this.categorys)
      let category = 0
      this.categorys.forEach(item=>{
        category += item
      })
      this.model.category = category
      console.log("this.model.category:"+this.model.category)
    },
    categorysChange2(){
      this.model.category = this.category2

    }
  }
}
</script>

<style scoped>

</style>
